import { EDUCATION_LEVEL_LABELS, formatMoney, currencyCodeSchema, type EducationLevel } from '@nest-recruit/shared';

// Display helpers for S14's screens. Empty is always `—` (06-qol §3), which the
// table and the fact lists render for a `null`.

const MONTHS_PER_YEAR = 12;

export function experienceLabel(months: number | null): string | null {
  if (months === null) return null;
  const years = Math.round((months / MONTHS_PER_YEAR) * 10) / 10;
  return `${years} ${years === 1 ? 'year' : 'years'}`;
}

export function educationLabel(level: EducationLevel | null): string | null {
  return level ? EDUCATION_LEVEL_LABELS[level] : null;
}

/** Money as minor units and a code, never a float (non-negotiable #7). */
export function salaryLabel(minor: string | null, currency: string | null): string | null {
  const code = currencyCodeSchema.safeParse(currency);
  if (minor === null || !code.success || !/^\d+$/.test(minor)) return null;
  return `${formatMoney({ amountMinor: BigInt(minor), currency: code.data })} a month`;
}

export function yesNo(value: boolean | null): string | null {
  if (value === null) return null;
  return value ? 'Yes' : 'No';
}

export function fileSize(bytes: number): string {
  const kilobytes = bytes / 1024;
  return kilobytes < 1024 ? `${Math.max(1, Math.round(kilobytes))} KB` : `${(kilobytes / 1024).toFixed(1)} MB`;
}
